<template>
  <audit-list :audits="audits" title="My Audits / Verifications" subtitle=" " :busy="isBusy" />
</template>

<script>
import AuditList from './AuditList.vue'
export default {
  name: 'MyAuditList',

  components: { AuditList },
  data () {
    return {
      audits: [],
      isBusy: true
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      await this.getAudits()
    },
    async getAudits () {
      if (this.activeGroup !== 'null') {
        try {
          this.isBusy = true
          const reply = await this.$api.get('/audits/by_creator')
          this.audits = reply.data
        } catch (e) {
          console.error(e)
        } finally {
          this.isBusy = false
        }
      }
    }
  }
}
</script>
